import TableCol from "./v-table-col.vue";
import Table from "./v-table.vue";
/* istanbul ignore next */
Table.install = function(Vue) {
  Vue.component(Table.name, Table);
  Vue.component(TableCol.name, TableCol);
};

export { Table, TableCol };
